import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/layout/index.vue'
import Page404 from '@/views/error/404.vue'

// 公共路由
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/404',
    component: Page404,
    hidden: true
  },
  {
    path: '/dashboard',
    redirect: '/chat',
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/chat',
    children: [
      // 对话模块
      {
        path: 'chat',
        name: 'Chat',
        component: () => import('@/views/chat/index.vue'),
        meta: { title: '对话', icon: 'chat' }
      },
      
      // // 网页模块
      // {
      //   path: 'webpage',
      //   name: 'Webpage',
      //   component: () => import('@/views/webpage/index.vue'),
      //   meta: { title: '网页', icon: 'webpage' }
      // },
      
      // // 企业微信模块
      // {
      //   path: 'wework',
      //   name: 'WeWork',
      //   component: () => import('@/views/wework/index.vue'),
      //   meta: { title: '企业微信', icon: 'wework' }
      // },
      
      // // 微信模块
      // {
      //   path: 'wechat',
      //   name: 'Wechat',
      //   component: () => import('@/views/wechat/index.vue'),
      //   meta: { title: '微信', icon: 'wechat' }
      // },
      
      // // 抖音模块
      // {
      //   path: 'douyin',
      //   name: 'Douyin',
      //   component: () => import('@/views/douyin/index.vue'),
      //   meta: { title: '抖音', icon: 'douyin' }
      // },
      
      // // 小红书模块
      // {
      //   path: 'xiaohongshu',
      //   name: 'Xiaohongshu',
      //   component: () => import('@/views/xiaohongshu/index.vue'),
      //   meta: { title: '小红书', icon: 'xiaohongshu' }
      // },
      
      // // 快手模块
      // {
      //   path: 'kuaishou',
      //   name: 'Kuaishou',
      //   component: () => import('@/views/kuaishou/index.vue'),
      //   meta: { title: '快手', icon: 'kuaishou' }
      // },
      
      // // 美团模块
      // {
      //   path: 'meituan',
      //   name: 'Meituan',
      //   component: () => import('@/views/meituan/index.vue'),
      //   meta: { title: '美团', icon: 'meituan' }
      // },
      
      // // 营销模块
      // {
      //   path: 'marketing',
      //   name: 'Marketing',
      //   component: () => import('@/views/marketing/index.vue'),
      //   meta: { title: '营销', icon: 'marketing' }
      // },
      
      // // 智能客服模块
      // {
      //   path: 'aiservice',
      //   name: 'AIService',
      //   component: () => import('@/views/aiservice/index.vue'),
      //   meta: { title: '智能客服', icon: 'aiservice' }
      // },
      
      // 客资模块
      {
        path: 'customer',
        name: 'Customer',
        component: () => import('@/views/customer/index.vue'),
        meta: { title: '客资', icon: 'customer' }
      },
      // 财务
      {
        path: '/finance',
        component: () => import('@/views/finance/index.vue'),
        name: 'Finance',
        meta: { title: '财务' },
        children: [
          {
            path: 'receivepayment',
            component: () => import('@/views/finance/receivepayment/index.vue'),
            name: 'ReceivePayment',
            meta: { title: '收款列表' }
          }
        ]
      },
      
      // // 统计模块
      // {
      //   path: 'statistics',
      //   name: 'Statistics',
      //   component: () => import('@/views/statistics/index.vue'),
      //   meta: { title: '统计', icon: 'statistics' }
      // },
      
      // 设置模块 - 只作为导航项
      {
        path: 'settings',
        name: 'Settings',
        meta: { title: '设置', icon: 'setting' }
      },
      // 测试路由 - 隐藏测试页面
      {
        path: 'test',
        name: 'Test',
        component: () => import('@/views/test.vue'),
        meta: { title: '测试页面', icon: 'test' },
        hidden: true
      },
      
      // 机器人详情页
      // {
      //   path: '/aiservice/detail/:id',
      //   component: () => import('@/views/aiservice/detail.vue'),
      //   name: 'BotDetail',
      //   meta: {
      //     title: '机器人管理'
      //   }
      // }
    ]
  },
  // 单独添加设置路由
  {
    path: '/settings',
    component: Layout,
    children: [
      //基础设置
      {
        path: 'baseset',
        component: () => import('@/views/settings/baseset/index.vue'),
        name: 'BaseSettings',
        meta: { title: '基础设置' },
        children: [
          {
            path: 'commonquestion',
            name: 'CommonQuestionSettings',
            component: () => import('@/views/settings/baseset/commonquestion.vue'),
            meta: { title: '常见问题设置' }
          },
          {
            path: 'personalquestion',
            name: 'PersonalQuestionSettings',
            component: () => import('@/views/settings/baseset/personalquestion.vue'),
            meta: { title: '个人问题设置' }
          },
          {
            path: 'autoreply',
            name: 'AutoReplySettings',
            component: () => import('@/views/settings/baseset/autoreply.vue'),
            meta: { title: '自动回复设置' }
            },
            {
              path: 'aiknowledgebase',
              name: 'AiKnowledgeBaseSettings',
              component: () => import('@/views/settings/baseset/aiknowledgebase.vue'),
              meta: { title: 'AI知识库设置' }
            }
        ]
      },
      // 企业微信设置
      {
        path: 'wework',
        component: () => import('@/views/settings/wework/index.vue'),
        name: 'WeWorkSettings',
        meta: { title: '企业微信设置' },
        redirect: '/settings/wework/config',
        children: [
          {
            path: 'config',
            component: () => import('@/views/settings/wework/config.vue'),
            name: 'WeWorkConfig',
            meta: { title: '基础配置' }
          },
          {
            path: 'account',
            component: () => import('@/views/settings/wework/account.vue'),
            name: 'WeWorkAccount',
            meta: { title: '账号管理' }
          },
          {
            path: 'chatarchive',
            component: () => import('@/views/settings/wework/chatarchive.vue'),
            name: 'WeWorkChatArchive',
            meta: { title: '会话存档' }
          },
          {
            path: 'department',
            component: () => import('@/views/settings/wework/department.vue'),
            name: 'WeWorkDepartment',
            meta: { title: '部门管理' }
          },
          {
            path: 'tag',
            component: () => import('@/views/settings/wework/tag.vue'),
            name: 'WeWorkTag',
            meta: { title: '标签管理' }
          },
          {
            path: 'message',
            component: () => import('@/views/settings/wework/message.vue'),
            name: 'WeWorkMessage',
            meta: { title: '消息管理' }
          },
          {
            path: 'moments',
            component: () => import('@/views/settings/wework/moments.vue'),
            name: 'WeWorkMoments',
            meta: { title: '朋友圈' }
          },
          {
            path: 'material',
            component: () => import('@/views/settings/wework/material.vue'),
            name: 'WeWorkMaterial',
            meta: { title: '素材库' }
          },
          {
            path: 'automation',
            component: () => import('@/views/settings/wework/automation.vue'),
            name: 'WeWorkAutomation',
            meta: { title: '自动化' }
          },
          {
            path: 'analytics',
            component: () => import('@/views/settings/wework/analytics.vue'),
            name: 'WeWorkAnalytics',
            meta: { title: '数据分析' }
          },
          {
            path: 'group',
            component: () => import('@/views/settings/wework/group.vue'),
            name: 'WeWorkGroup',
            meta: { title: '群管理' }
          },
          {
            path: 'customer',
            component: () => import('@/views/settings/wework/customer.vue'),
            name: 'WeWorkCustomer',
            meta: { title: '客户管理' }
          },
          {
            path: 'broadcast',
            component: () => import('@/views/settings/wework/broadcast.vue'),
            name: 'WeWorkBroadcast',
            meta: { title: '群发助手' }
          }
        ]
      },
      //绑定设置
      {
        path: 'binding',
        component: () => import('@/views/settings/binding/index.vue'),
        name: 'BindingSettings',
        meta: { title: '绑定设置' },
        children: [
          {
            path: '',
            redirect: 'wechat',
            name: 'BindingSettingsRedirect'
          },
          {
            path: 'website',
            component: () => import('@/views/settings/binding/website.vue'),
            name: 'WebSiteBinding',
            meta: { title: '网站' }
          },
          {
            path: 'wechat',
            component: () => import('@/views/settings/binding/wechat.vue'),
            name: 'WechatBinding',
            meta: { title: '微信' }
          },
          {
            path: 'douyin',
            component: () => import('@/views/settings/binding/douyin.vue'),
            name: 'DouyinBinding',
            meta: { title: '抖音' }
          },
          {
            path: 'xiaohongshu',
            component: () => import('@/views/settings/binding/xiaohongshu.vue'),
            name: 'XiaohongshuBinding',
            meta: { title: '小红书' }
          },
          {
            path: 'kuaishou',
            component: () => import('@/views/settings/binding/kuaishou.vue'),
            name: 'KuaishouBinding',
            meta: { title: '快手' }
          },
          {
            path: 'meituan',
            component: () => import('@/views/settings/binding/meituan.vue'),
            name: 'MeituanBinding',
            meta: { title: '美团' }
          },
          {
            path: 'weibo',
            component: () => import('@/views/settings/binding/weibo.vue'),
            name: 'WeiboBinding',
            meta: { title: '微博' }
          }
        ]
      },
      // 对话设置
      {
        path: 'chat',
        component: () => import('@/views/settings/chat/index.vue'),
        name: 'ChatSettings',
        meta: { title: '对话设置' },
        children: [
          {
            path: 'allocation',
            component: () => import('@/views/settings/chat/allocation.vue'),
            name: 'ServiceAllocation',
            meta: { title: '客服分配' }
          }
        ]
      },
      // 客资设置
      {
        path: 'customer',
        component: () => import('@/views/settings/customer/index.vue'),
        name: 'CustomerSettings',
        meta: { title: '客资设置' },
        children: [
          {
            path: 'tags',
            component: () => import('@/views/settings/customer/tags.vue'),
            name: 'CustomerTags',
            meta: { title: '标签' }
          },
          {
            path: 'notification',
            component: () => import('@/views/settings/customer/notification.vue'),
            name: 'CustomerNotification',
            meta: { title: '推送通知' }
          },
          {
            path: 'rules',
            component: () => import('@/views/settings/customer/rules.vue'),
            name: 'CustomerRules',
            meta: { title: '保存规则' }
          },
          {
            path: 'sources',
            component: () => import('@/views/settings/customer/sources.vue'),
            name: 'CustomerSources',
            meta: { title: '自定义来源' }
          },
          {
            path: 'blacklist',
            component: () => import('@/views/settings/customer/blacklist.vue'),
            name: 'CustomerBlacklist',
            meta: { title: '黑名单' }
          },
          {
            path: 'phonecheck',
            component: () => import('@/views/settings/customer/phonecheck.vue'),
            name: 'PhoneCheck',
            meta: { title: '空号检测' }
          }
        ]
      },
      // 客服管理
      {
        path: 'service',
        component: () => import('@/views/settings/service/index.vue'),
        name: 'ServiceSettings',
        meta: { title: '客服管理' }
      },
      // 手机值班
      {
        path: 'duty',
        component: () => import('@/views/settings/duty/index.vue'),
        name: 'DutySettings',
        alias: 'mobile',
        meta: { title: '手机值班' }
      },
      // 通知设置
      {
        path: 'notification',
        component: () => import('@/views/settings/notification/index.vue'),
        name: 'NotificationSettings',
        meta: { title: '通知设置' }
      },
      // 客户端设置
      {
        path: 'client',
        component: () => import('@/views/settings/client/index.vue'),
        name: 'ClientSettings',
        meta: { title: '客户端设置' }
      },
      // 充值续费
      {
        path: 'payment',
        component: () => import('@/views/settings/payment/index.vue'),
        name: 'PaymentSettings',
        meta: { title: '充值续费' }
      },
      // 开发者配置
      {
        path: 'developer',
        component: () => import('@/views/settings/developer/index.vue'),
        name: 'DeveloperSettings',
        meta: { title: '开发者配置' }
      },
      {
        path: 'wechat',
        component: () => import('@/views/settings/wechat/index.vue'),
        name: 'WechatSettings',
        meta: { title: '微信设置' }
      },
      {
        path: 'system',
        component: () => import('@/views/settings/system/index.vue'),
        name: 'SystemSettings',
        meta: { title: '系统设置' }
      }
    ]
  },
  

  // 添加个人中心路由
  {
    path: '/profile',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'Profile',
        component: () => import('@/views/profile/index.vue'),
        meta: { title: '个人中心', icon: 'user' }
      }
    ]
  },
  // 404页面必须放在最后
  { path: '/:pathMatch(.*)*', redirect: '/404', hidden: true }
]

// 创建路由
const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes,
  // 修复滚动行为
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 这里可以添加登录验证等逻辑
  next()
})

export default router 